import { render, staticRenderFns } from "./BikyConfigScheduleBasic.vue?vue&type=template&id=3548a6d3&scoped=true&"
import script from "./BikyConfigScheduleBasic.vue?vue&type=script&lang=ts&"
export * from "./BikyConfigScheduleBasic.vue?vue&type=script&lang=ts&"
import style0 from "./BikyConfigScheduleBasic.vue?vue&type=style&index=0&id=3548a6d3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3548a6d3",
  null
  
)

export default component.exports